export default __webpack_public_path__ + "static/media/mode-5.ead21ca2.svg";